export default {
  languageTitle: 'Idioma',
  languageHelp: 'El idioma en que se le muestra esta aplicación. Lo que todavía no está traducido se '
    + 'muestra en inglés.',
  useMyDeviceLanguage: 'Usar el idioma de mi teléfono o computadora',
  useMyDeviceLanguageHelp: 'No hay ninguna opción guardada — decide su teléfono o su computadora, y '
    + 'si no tienen respuesta, decide la configuración de su empresa.',
  languageSaved: 'Idioma guardado',
  languageSaveFailed: 'No se pudo guardar. Intente otra vez.',
  languageForUser: 'Idioma',
  languageForUserHelp: 'El idioma que lee esta persona. Póngalo aquí si no puede leer la pantalla '
    + 'donde lo pondría ella misma.',
  notChosen: 'Sin definir',
  companyDefaultLanguage: 'Idioma de la empresa',
  companyDefaultLanguageHelp: 'Lo que ve todo el mundo — incluida la página para iniciar sesión, '
    + 'antes de que nadie haya entrado. La opción de cada persona siempre gana sobre esta.',
  noCompanyDefault: 'Sin idioma de empresa',
  companyDefaultLanguageNotStickers: 'Esto es para quienes inician sesión. La hoja de la calcomanía '
    + 'QR la leen personas que no inician sesión, así que tiene su propio idioma de inicio en '
    + 'Formularios → Reglas para firmar.',
}
